export class HasBookingsFilter {}
